
import React, { useState, useEffect } from 'react'
import { CCard, CRow, CCol, CCardHeader, CCardBody , CSpinner} from '@coreui/react'
import { fs } from '../../../firebase'

export default function VerseOfDay() {
  const [verse, setVerse] = useState({ bookName: '', chapter: '', number: '', content: '' })
  const [loading, setLoading] = useState(false)

  async function getVerseOftheDay() {
    setLoading(true)
    try {
      const result = await fs.collection('versesOfDay')
        .orderBy('createdAt', 'desc').limit(1).get()
      let verseOfDay = result.docs.length ? result.docs[0].data() : null

      if (verseOfDay) {
        const bookDocSnapshot = await fs.collection('books').doc(`${verseOfDay.book}`).get()
        const book = bookDocSnapshot.data()
        console.log(book)
        const chapter = book.chapters.find(item => item.number == verseOfDay.chapter)
        const verse = chapter.verses.find(item => item.number == verseOfDay.verse)

        setVerse({
          bookName: book.name,
          chapter: verseOfDay.chapter,
          number: verseOfDay.verse,
          content: verse.content
        })
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    getVerseOftheDay()
  }, [])

  return (
    <>
      <CRow className="mt-3">
        <CCol>
          <h5>Verse of the Day</h5>
        </CCol>
      </CRow>
      {
        loading ?
          <div className="col w-100 text-center mt-3">
            <CSpinner
            />
          </div> :
          <CRow>
            <CCol>
              <CCard>
                <CCardHeader>
                  <strong>{verse.bookName} {verse.chapter}{verse.number && ':'}{verse.number}</strong>
                </CCardHeader>
                <CCardBody>
                  <p>{verse.content}</p>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
      }
    </>
  )
}
